export default "__VITE_ASSET__D36Sw_jr__"